import { render, staticRenderFns } from "./LandingComoCols.vue?vue&type=template&id=43efce40"
import script from "./LandingComoCols.vue?vue&type=script&lang=js"
export * from "./LandingComoCols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports